import CivicPlusSwitchers from 'src/utils/CivicPlusSwitchers.esm.js'

interface OrgService {
  accessToken: string
  endpoint: string
  idToken?: string
}

interface Application {
  id: string
  name: string
  organizationId: string
  productType?: number
  productUri?: string
  clientId?: number
  clientName?: string
  typeId?: number
  typeName?: string
  postLoginRedirectUris?: string[]
  postLogoutRedirectUris?: string[]
  organization?: string
  visibility?: boolean | string
  publicUri?: string
  autoSignInUri?: string
}

interface User {
  id?: string
  email?: string
  firstName?: string
  lastName?: string
  role?: string | string[]
  accessToken?: string
  idToken?: string
}

interface BrandingSettings {
  friendlyName?: string
  organizationWebsite?: string
  primaryColor?: string
  standardLogo?: string
  printLogo?: string
  reverseLogo?: string
}

interface CppOrganizationSettings {
  brandingSettings?: BrandingSettings
  forceTwoFactor?: boolean
  passwordExpirationDays?: number
  provider?: number
  timeZone?: string
}

interface CppOrganization {
  id: string
  name: string
  owners: User[]
  applications: Application[]
  created: string
  createdById: string
  lastModified?: string
  lastModifiedById?: string
  applicationCount: number
  ownerCount: number
  settings: CppOrganizationSettings
  friendlyName?: string
  location?: {
    longitude: number
    latitude: number
  }
  timeZone?: string
}

interface OrgSwitcherProps {
  orgServiceSdk: OrgService
  currentOrg?: CppOrganization
  onOrgSelect?: (state: CppOrganization) => void
  onError?: (e: Error) => void
  pageType?: 'public' | 'admin'
  showGeolocation?: boolean
  showRecentOrganizations?: boolean
  hide?: boolean
  superUserRole?: string
  isReadOnlyUser?: boolean
}

interface AppSwitcherProps {
  currentOrg?: CppOrganization
}

interface CivicPlusSwitchersConfig {
  orgSwitcherNode?: string
  appSwitcherNode?: string
  orgService: OrgService
  currentOrg?: CppOrganization
  initialOrg?: string
  OrgSwitcherProps?: Partial<OrgSwitcherProps>
  AppSwitcherProps?: Partial<AppSwitcherProps>
}

const config: CivicPlusSwitchersConfig = {
  orgService: {
    accessToken: '',
    endpoint: `${import.meta.env.VITE_CP_ORGSERVICE_URL}/api`
  }
}

/**
 * usage:
 * <div id="cp-appSwitcher" />
 * useCivicPlusSwitchers('cp-appSwitcher')
 */
export async function useCivicPlusSwitchers(
  orgId?: string,
  accessToken?: string,
  appSwitcherNodeId?: string,
  appSwitcherProps?: Partial<AppSwitcherProps>,
  orgSwitcherNodeId?: string,
  orgSwitcherProps?: Partial<OrgSwitcherProps>
) {
  config.initialOrg = orgId
  config.orgService.accessToken = accessToken

  if (appSwitcherNodeId) {
    config.appSwitcherNode = appSwitcherNodeId
    config.AppSwitcherProps = appSwitcherProps
  }
  if (orgSwitcherNodeId) {
    config.orgSwitcherNode = orgSwitcherNodeId
    config.OrgSwitcherProps = orgSwitcherProps
  }

  CivicPlusSwitchers.init(config)
}
